export default "__VITE_ASSET__DkZQ7J3O__"